import { DominatrixVisualStyleOptionsType } from '@/pages/Onboarding/options/DominatrixVisualStyle/types';

export const DOMINATRIX_VISUAL_STYLE_OPTIONS: DominatrixVisualStyleOptionsType =
  [
    {
      id: 'latex',
      title: 'Tall and commanding in latex',
    },
    {
      id: 'corset',
      title: 'Elegant in heels and corset',
    },
    {
      id: 'casual',
      title: 'Casual, but deadly',
    },
    {
      id: 'dress',
      title: 'Elegant in form-fitting dress',
    },
  ];
